import React from 'react';
import CohortRow from './CohortRow';

const CohortsTableRows = ({
  category,
  className,
  columns,
  items,
  onCheckBoxClick,
  selectable,
}) => (
  items.map((item, index) => (
    <CohortRow
      className={className}
      key={`cohorts_table_row_${item.id}`}
      category={category}
      cohort={item}
      onCheckBoxClick={onCheckBoxClick}
      upward={index > 4}
      columns={columns}
      selectable={selectable}
    />
  ))
);

export default CohortsTableRows;
